<script setup>
import {Head, Link, usePage} from '@inertiajs/inertia-vue3';
import {computed, ref} from "vue";
import HeaderNavigation from "@/Layouts/HeaderNavigation.vue";
import SidebarNavigation from "@/Layouts/SidebarNavigation.vue";
import Banner from "@/Components/Banner.vue";
import {FwbBreadcrumb, FwbBreadcrumbItem} from "flowbite-vue";

defineProps({
  title: String,
  breadcrumbs: {
    type: Array,
    default() {
      return []
    }
  }
});

const sideBar = ref((window.localStorage.getItem('sidebar-toggle') || 'true') === 'true');
const page = usePage();
const tenantManagerOnlyMode = computed(() => page.props.value.app?.tenantManagerOnlyMode === true);
const showSidebar = computed(() => tenantManagerOnlyMode.value || sideBar.value);

window.addEventListener('sidebar-toggle-updated', (event) => {
  sideBar.value = event.detail;
});

const homeUrl = computed(() => (
  tenantManagerOnlyMode.value
    ? route('admin.tenant-manager.index')
    : route('dashboard')
));

</script>

<template>
  <div class="min-h-screen bg-white flex flex-col">
    <Head :title="title">

      <link rel="stylesheet" href="https://pro.fontawesome.com/releases/v5.10.0/css/all.css"
            integrity="sha384-AYmEC3Yw5cVb3ZcuHtOA93w35dYTsvhLPVnYs9eStHfGJvOvKxVfELGroGkvsg+p"
            crossorigin="anonymous"/>
      <link rel="stylesheet" href="https://unpkg.com/vue-multiselect@2.1.6/dist/vue-multiselect.min.css">
    </Head>

    <p class="sticky top-0 text-center text-xl font-bold p-1 bg-yellow-200 z-100"
       v-if="$page.props.environment !== 'production'">
      <span>TESTING</span>
    </p>

    <div class="flex-1 flex flex-col">
      <div class="grid grid-cols-12 w-full flex-1">
        <div class="xl:col-span-2 lg:col-span-3 md:col-span-4 col-span-12" :class="{'hidden': !showSidebar}">
          <SidebarNavigation :page-props="$page.props"/>
        </div>
        <main class="col-span-12 flex flex-col min-h-full" :class="showSidebar ? ['xl:col-span-10','lg:col-span-9', 'md:col-span-8'] : []">
          <HeaderNavigation :page-props="$page.props"></HeaderNavigation>
          <FwbBreadcrumb solid class="bg-white border-0">
            <FwbBreadcrumbItem home :href="homeUrl">
              <span class="text-gray-700 font-semibold text-sm">Home</span>
            </FwbBreadcrumbItem>
            <FwbBreadcrumbItem class="text-gray-700 font-medium" v-for="breadcrumb in breadcrumbs">
              <Link :href="breadcrumb.href" v-if="breadcrumb.href">
                <span class="text-gray-700 font-semibold text-sm" v-text="breadcrumb.title"></span>
              </Link>
              <span class="text-gray-700 font-semibold text-sm" v-text="breadcrumb.title" v-else></span>
            </FwbBreadcrumbItem>
          </FwbBreadcrumb>
          <div v-if="$slots.header">
            <div class="mx-auto py-6 px-4 sm:px-6 lg:px-8">
              <slot name="header"/>
            </div>
          </div>
          <div class="flex-1">
            <slot></slot>
          </div>
        </main>
      </div>
      <div class="max-w-3xl sticky bottom-0 z-100">
        <Banner></Banner>
      </div>

    </div>
  </div>
</template>
